/**
 * SynapseKind-related API helpers.
 * Mirrors the NodeKind service structure for consistency.
 */
export const createSynapseKindService = (apiClient) => {
  if (!apiClient) {
    throw new Error('apiClient instance is required to create SynapseKind service');
  }

  return {
    /**
     * Create a new synapse kind.
     * @param {Object} synapseKindData
     * @param {Object} synapseKindData.synapseKind - Main synapse kind data
     * @param {string} synapseKindData.synapseKind.kindName - Kind name (required)
     * @param {string} [synapseKindData.synapseKind.description] - Description
     * @returns {Promise<Object>} API response payload
     */
    createSynapseKind: async (synapseKindData) => {
      if (!synapseKindData.synapseKind || !synapseKindData.synapseKind.kindName) {
        throw new Error('kindName is required to create synapse kind');
      }
      const response = await apiClient.post('/edge-kinds', synapseKindData);
      return response.data;
    },

    /**
     * Retrieve a synapse kind by its ID.
     * @param {string} synapseKindId - Synapse kind identifier (required)
     * @returns {Promise<Object>} API response payload
     */
    getSynapseKind: async (synapseKindId) => {
      if (!synapseKindId) {
        throw new Error('synapseKindId is required to fetch synapse kind details');
      }
      const response = await apiClient.get(`/edge-kinds/${synapseKindId}`);
      return response.data;
    },

    /**
     * List all available synapse kinds.
     * @param {Object} [options] - Optional parameters
     * @param {number} [options.page=1] - Page number
     * @param {number} [options.pageSize=25] - Records per page
     * @returns {Promise<Object>} API response payload
     */
    listSynapseKinds: async (options = {}) => {
      const params = {
        page: options.page || 1,
        pageSize: options.pageSize || 25,
      };

      if (options.query) {
        params.query = options.query;
      }

      const response = await apiClient.get('/edge-kinds', { params });
      return response.data;
    },
  };
};

export default createSynapseKindService;



